import { Fetch } from 'lib';

type RequestResponses = {};

type RequestParameters = {};

type RequestBody = {
  brandsIds: string[];
};

const updateMainPageBrands = async (body: RequestBody) =>
  await Fetch<RequestResponses, RequestParameters, RequestBody>({
    url: 'adminPageBuilder/updateMainPageBrands',
    method: 'PATCH',
    body,
  });

export { updateMainPageBrands };
